import { Typography, Grid, Box, Divider } from "@material-ui/core";
import { deepOrange, grey, blueGrey, green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import {
  canRelocate,
  getLocationViewName,
} from "../../../../utils/locationUtils";
import { getInventoryQuantity } from "../../../../utils/utils";
import { useInventorySearchContext } from "../context";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1001,
  },
  mapContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    minHeight: theme.spacing(24),
    width: "100%",
  },
  mapContainerMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    minHeight: theme.spacing(24),
    width: "100%",
  },
  bayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
    alignItems: "center",
    alignContent: "space-between",
    border: "1px solid #b0bec5",
    borderRadius: theme.spacing(1),
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
  },
  levelContainer: {
    border: "1px solid",
    borderColor: blueGrey[500],
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  locationAvatar: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(
      theme.palette.type === "dark" ? grey[400] : grey[300]
    ),
    backgroundColor: theme.palette.type === "dark" ? grey[400] : grey[300],
    borderColor: theme.palette.type === "dark" ? grey[400] : grey[300],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "3px solid",
    borderRadius: theme.spacing(0.5),
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  locationUsedAvatar: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(
      theme.palette.type === "dark" ? grey[400] : grey[300]
    ),
    backgroundColor: theme.palette.type === "dark" ? grey[400] : grey[300],
    borderColor:
      theme.palette.type === "dark" ? deepOrange[500] : deepOrange[500],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "3px solid",
    borderRadius: theme.spacing(0.5),
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  selectedLocationAvatar: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    borderColor: deepOrange[500],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "3px solid",
    borderRadius: theme.spacing(0.5),
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  locationAvailableAvatar: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.getContrastText(green[600]),
    backgroundColor: green[600],
    borderColor: green[600],
    margin: theme.spacing(0.5),
    whiteSpace: "nowrap",
    border: "3px solid",
    borderRadius: theme.spacing(0.5),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: green[600],
      color: theme.palette.getContrastText(green[600]),
    },
    width: "100%",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  redCircle: {
    position: "absolute",
    top: -theme.spacing(1.25),
    left: -theme.spacing(1.25),
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    borderStyle: "solid",
    borderWidth: theme.spacing(0.75),
    borderRadius: theme.spacing(0.75),
    borderColor: deepOrange[500],
  },
}));

export const StructuredAisle = () => {
  const { state, dispatch } = useInventorySearchContext();
  const {
    currentInventory,
    selectedLocation,
    selectedInventoryItem,
    searchInventoryItemsMap,
    selectedAisle,
    bayList,
    originalInventoryItem,
    showInventoryQuantity,
    disableRelocateValidation,
    inventoryItemBayList,
  } = state;
  const classes = useStyles();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleSelectLocation = (location) => {
    debugger;
    if (!location.capacityUsed) location.capacityUsed = 0;
    if (location.id === selectedLocation?.id) {
      dispatch({ type: "SET_SELECTED_LOCATION", payload: { location: null } });
    } else {
      dispatch({ type: "SET_SELECTED_LOCATION", payload: { location } });
    }
  };

  const getFullName = (location, size = 16) => {
    if (!location) return "";
    const name = getLocationViewName(location);
    if (!isSmall) return name;
    if (name.length <= size) return name;
    return name.substring(0, size - 3) + "...";
  };

  const getLocationAvatarClassName = (location) => {
    // if (location.bay === 1 && location.level === 2 && location.position === 3) {
    //     debugger;
    // }

    if (location.id === selectedLocation?.id)
      return classes.selectedLocationAvatar;
    if (originalInventoryItem?.locationId === location.id) {
      if (!selectedLocation) return classes.selectedLocationAvatar;
      return classes.locationUsedAvatar;
    }
    const available = canRelocate(
      bayList,
      location,
      selectedInventoryItem,
      currentInventory,
      disableRelocateValidation,
      inventoryItemBayList
    );

    if (!available) return classes.locationAvatar;
    return classes.locationAvailableAvatar;
  };

  const getCapcityUsedText = (location) => {
    if (
      !showInventoryQuantity ||
      (!selectedLocation && selectedAisle?.locationLoad?.other.selected) ||
      selectedLocation?.locationLoad?.other.selected
    ) {
      return `${location.capacityUsed ? location.capacityUsed : 0}%`;
    } else {
      const inventoryLoadType =
        currentInventory.reloadYardCommodity.commodity.locationLoadType;
      if (inventoryLoadType === "other" || inventoryLoadType === "container")
        return "";
      return getInventoryQuantity(location, currentInventory).name;
    }
  };

  if (!selectedAisle?.id || bayList?.length === 0) return <></>;

  return (
    <>
      <Grid item xs={12}>
        <div
          className={
            isSmall ? classes.mapContainerMobile : classes.mapContainer
          }
        >
          {bayList?.map((bay, bayIdx) => (
            <div className={classes.bayContainer} key={bayIdx}>
              <Box m={1}>
                <Typography>{`Bay ${
                  (bayIdx + 1 < 10 ? " 0" : " ") + (bayIdx + 1)
                }`}</Typography>
              </Box>
              <Divider />
              {bay?.map((level, idx) => (
                <div className={classes.levelContainer} key={idx}>
                  {level.map((location) => {
                    return (
                      <div
                        key={location.id}
                        className={getLocationAvatarClassName(location)}
                        onClick={() => handleSelectLocation(location)}
                      >
                        <Typography align="center" variant="body2">
                          {getFullName(location)}
                        </Typography>
                        <Typography align="center" variant="body2">
                          {getCapcityUsedText(location)}
                        </Typography>
                        {searchInventoryItemsMap[location.id] && (
                          <Box className={classes.redCircle}></Box>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          ))}
        </div>
      </Grid>
    </>
  );
};
